<template>
    <div class="feeds-list">
        <ButtonTabs v-model="params.type" :options="items" @change="typeChange" @ready="refresh" state-key="feed-type" class="tabs"/>
        <a-spin :spinning="loading">
            <div class="wrapper" v-if="result.total">
                <div class="feeds" v-for="item in result.data" :key="item.id" :style="{width: colWidth+'px'}">
                    <div class="image">
                        <ResourceImg :id="item['photo']['thumb_id']" :size="colWidth" :width="colWidth" :height="colWidth"/>
                        <div class="extend">
                            <div class="background"></div>
                            <div class="information">
                                <div>{{item["photo"]["file_name"]}}</div>
                                <div v-if="item['extend']['price']">
                                    打赏额：{{item["extend"]["price"] | formatCNF}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="operator">
                        <UserAvatar :id="item['operator']['avatar']" :size="20"/>
                        {{item['operator']['nick'] || "匿名用户"}}
                    </div>
                </div>
            </div>
            <div v-else :style="{height: colWidth+44+'px'}" class="empty">
                <a-empty/>
            </div>
        </a-spin>
        <div style="padding: 15px 0; float: left; text-align: right; width: 100%;">
            <a-pagination
                :hideOnSinglePage="false" :pageSize="params.page_size" :total="result.total"
                @change="load" class="pagination" v-model="params.page_no"/>
        </div>
    </div>
</template>

<script>
    import api from "../../../../utils/api";
    import func from "../../../../utils/func";
    import UserAvatar from "../../../../comps/UserAvatar";
    import DelayLoading from "../../../../comps/DelayLoading";
    import ButtonTabs from "../../../../comps/ButtonTabs";
    import ResourceImg from "../../../../comps/ResourceImg";

    export default {
        name: "FeedsLine",
        props: {albumId: String},
        components: {ResourceImg, ButtonTabs, UserAvatar},
        mixins: [DelayLoading],
        data() {
            return {
                items: [
                    {label: "下载", value: 3, icon: "download"},
                    {label: "打赏", value: 2, icon: "pay-circle"},
                    {label: "收藏", value: 1, icon: "star"},
                ],
                params: {
                    type: 3,
                    page_no: 1,
                    page_size: 120,
                },
                result: {
                    total: 0,
                    data: [],
                },
            }
        },
        computed: {
            colWidth() {
                return func.computedColWidth({
                    count: 8, gutter: 16, range: [180, 210],
                    width: this.$store.getters["layout/contentWidth"] - 34
                });
            },
        },
        methods: {
            load() {
                this.withLoading(500, () => {
                    return api.v1.album.feeds.search(this.albumId, this.params);
                }).then(res => this.result = res);
            },
            refresh() {
                this.result.total = 0;
                this.result.data = [];
                this.complete = false;
                this.params.page_no = 1;
                this.load();
            },
            typeChange(type) {
                this.params.type = type;
                this.refresh();
            }
        }
    }
</script>

<style scoped lang="less">
    .feeds-list {
        .tabs {
            margin-bottom: 13px;
        }

        .wrapper {
            margin: -6px;
        }

        .empty {
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            border: 1px #e8e8e8 solid;
        }

        .feeds {
            float: left;
            margin: 8px;

            .image {
                position: relative;

                img {
                    width: 100%;
                    display: block;
                    border-radius: 4px 4px 0 0;
                }

                .extend {
                    left: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 1000;
                    color: #ffffff;
                    text-align: center;
                    line-height: 20px;
                    position: absolute;

                    .background {
                        opacity: 0.5;
                        z-index: -1;
                        width: 100%;
                        height: 100%;
                        background: #000;
                        position: absolute;
                    }

                    .information {
                        padding: 5px 0;
                    }
                }
            }

            .operator {
                padding: 6px 10px;
                line-height: 22px;
                background: #e8e8e8;
                border-radius: 0 0 4px 4px;

                .avatar {
                    float: left;
                    margin-right: 8px;
                }
            }
        }
    }
</style>
